<template>
    <div class="view view--login">
        <settings />
    </div>
</template>

<script>
    import settings from '../../components/Settings.vue';

    export default {
        components: {
            settings
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/settings/Index.vue